"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StickyBar = StickyBar;
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function StickyBar({
  children,
  drawerWidth,
  variant
}) {
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: "#fff",
    borderTop: variant === 'outlined' ? '1px solid rgb(221, 224, 231)' : 0,
    bottom: 0,
    boxShadow: variant === 'outlined' ? 0 : '0px -2px 6px 0px rgba(137, 137, 137, 0.25)',
    boxSizing: "border-box",
    left: 0,
    paddingLeft: {
      xs: 1,
      sm: `${drawerWidth + 8}px`
    },
    paddingRight: 1,
    paddingY: 1,
    position: "fixed",
    width: "100%",
    zIndex: ({
      zIndex
    }) => zIndex.drawer - 1
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 2,
    justifyContent: "flex-end"
  }, children));
}